import Color from 'color';
import { LIGHTER_BLACK, WHITE } from './colors';

export const invertBackground = (backgroundColor: string) =>
  new Color(backgroundColor).isDark() ? WHITE : LIGHTER_BLACK;
